import { useEffect, useRef, useState } from 'react'

const TABS = ['IMPORTANT', 'PRODUCT', 'PROMOTION']

interface NotificationPopoverProps {
    open: boolean
    onClose: () => void
}

export default function NotificationPopover({ open, onClose }: NotificationPopoverProps) {
    const ref = useRef<HTMLDivElement>(null)
    const [activeTab, setActiveTab] = useState('IMPORTANT')

    // 👉 Click outside để đóng
    useEffect(() => {
        if (!open) return

        function handleClickOutside(e: MouseEvent) {
            if (ref.current && !ref.current.contains(e.target as Node)) {
                onClose()
            }
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => document.removeEventListener('mousedown', handleClickOutside)
    }, [open, onClose])

    if (!open) return null

    return (
        <div
            ref={ref}
            className="MuiPaper-root MuiMenu-paper styles_notifyWrap__BH8_d MuiPopover-paper MuiPaper-elevation0 MuiPaper-rounded"
            tabIndex={-1}
            style={{
                opacity: 1,
                transform: 'translateY(5px)',
                transition: 'opacity 225ms cubic-bezier(0.4, 0, 0.2, 1)',
                position: 'absolute',
                top: 32,
                left: 909,
                transformOrigin: '400px 0px',
                zIndex: 1400,
            }}
        >
            {/* === GIỮ NGUYÊN NỘI DUNG BÊN TRONG === */}
            <ul
                className="MuiList-root MuiMenu-list MuiList-padding"
                role="menu"
                tabIndex={-1}
                style={{
                    paddingRight: 15,
                    width: 'calc(100% + 15px)',
                }}
            >
                <div className="styles_notifyContentTop__ZIytL MuiBox-root css-0" tabIndex={0}>
                    <div className="MuiBox-root css-0">
                        <h5 className="MuiTypography-root styles_notifyTitle__nl0fr MuiTypography-h5">
                            Thông báo
                        </h5>
                    </div>
                </div>

                <div className="MuiBox-root css-0" id="notificationTab_container">
                    <div className="MuiTabs-root styles_notification_container__yJ6wA css-1vby6pt">
                        <div className="MuiTabs-scroller MuiTabs-fixed" style={{ overflow: 'hidden' }}>
                            <div className="MuiTabs-flexContainer" role="tablist">

                                {/* IMPORTANT */}
                                <button
                                    className={`
                                        MuiButtonBase-root MuiTab-root MuiTab-textColorInherit
                                        styles_labelTab__8z_uZ css-1xmh8h6
                                        ${activeTab === 'IMPORTANT' ? 'Mui-selected' : ''}
                                    `}
                                    type="button"
                                    role="tab"
                                    aria-selected={activeTab === 'IMPORTANT'}
                                    onClick={() => setActiveTab('IMPORTANT')}
                                >
                                    <span className="MuiTab-wrapper">
                                        <div className="MuiBox-root css-1utx3w7">Quan trọng</div>
                                    </span>
                                </button>

                                {/* PRODUCT */}
                                <button
                                    className={`
                                        MuiButtonBase-root MuiTab-root MuiTab-textColorInherit
                                        styles_labelTab__8z_uZ css-1xmh8h6
                                        ${activeTab === 'PRODUCT' ? 'Mui-selected' : ''}
                                    `}
                                    type="button"
                                    role="tab"
                                    aria-selected={activeTab === 'PRODUCT'}
                                    onClick={() => setActiveTab('PRODUCT')}
                                >
                                    <span className="MuiTab-wrapper">
                                        <div className="MuiBox-root css-1utx3w7">Sản phẩm</div>
                                    </span>
                                </button>

                                {/* PROMOTION */}
                                <button
                                    className={`
                                        MuiButtonBase-root MuiTab-root MuiTab-textColorInherit
                                        styles_labelTab__8z_uZ css-1xmh8h6
                                        ${activeTab === 'PROMOTION' ? 'Mui-selected' : ''}
                                    `}
                                    type="button"
                                    role="tab"
                                    aria-selected={activeTab === 'PROMOTION'}
                                    onClick={() => setActiveTab('PROMOTION')}
                                >
                                    <span className="MuiTab-wrapper">
                                        <div className="MuiBox-root css-1utx3w7">Khuyến mãi</div>
                                    </span>
                                </button>

                            </div>

                            {/* INDICATOR */}
                            <span
                                className="MuiTabs-indicator"
                                style={{
                                    width: 133.328,
                                    left:
                                        activeTab === 'IMPORTANT'
                                            ? 0
                                            : activeTab === 'PRODUCT'
                                                ? 133.328
                                                : 266.656,
                                }}
                            >
                                <span className="MuiTabs-indicatorSpan" />
                            </span>
                        </div>
                    </div>

                    {/* TAB PANEL - IMPORTANT */}
                    {activeTab === 'IMPORTANT' && (
                        <div
                            className="MuiTabPanel-root styles_tabPanel_container__M53so tabPanel"
                            role="tabpanel"
                        >
                            <div className="styles_notification_tabContainer__lUnx6 MuiBox-root css-0">

                                <div className="styles_dateLabel__tqB9r MuiBox-root css-0">
                                    <p className="MuiTypography-root MuiTypography-body1">
                                        Quá 30 ngày
                                    </p>
                                </div>

                                {/* ITEM 1 */}
                                <a
                                    className="styles_mobile_rootBase__8z7PQ styles_notificationsItem__Y42KH styles_read__WIgTK"
                                    href="/cart"
                                >
                                    <div className="MuiBox-root css-1hqz9cp">
                                        <div className="MuiBox-root css-c6deql">
                                            <div className="MuiBox-root css-1mcghfl">
                                                <div className="MuiBox-root css-vv12sd">
                                                    <p
                                                        className="MuiTypography-root styles_notification_label__M5clx MuiTypography-body2"
                                                        style={{ color: 'rgb(14, 25, 131)', border: '1px solid rgb(14, 25, 131)' }}
                                                    >
                                                        Đơn giá
                                                    </p>
                                                </div>
                                                <small className="styles_createdAt__cgZM_">
                                                    2 tháng trước
                                                </small>
                                            </div>
                                        </div>

                                        <div
                                            className="styles_notificationChild_container__vbuxp MuiBox-root css-dtg2nl"
                                            style={{ columnGap: 12 }}
                                        >
                                            <div className="styles_isRead___fiA9 MuiBox-root css-0" />
                                            <div className="MuiBox-root css-1821gv5">
                                                <div
                                                    style={{
                                                        color: 'rgb(121, 121, 121)',
                                                        fontSize: 14,
                                                        fontFamily: 'ggsr',
                                                        fontWeight: 400,
                                                    }}
                                                >
                                                    Sản phẩm Phil domina Hydroquinone Phil Inter (T/10gr)
                                                    đã có sự tăng giá bán so với lúc bạn để vào giỏ hàng,
                                                    vui lòng kiểm tra lại trước khi thanh toán!
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </a>

                                {/* ITEM 2 */}
                                <a
                                    className="styles_mobile_rootBase__8z7PQ styles_notificationsItem__Y42KH styles_read__WIgTK"
                                    href="/my-account"
                                >
                                    <div className="MuiBox-root css-1hqz9cp">
                                        <div className="MuiBox-root css-c6deql">
                                            <div className="MuiBox-root css-1mcghfl">
                                                <div className="MuiBox-root css-1azo8rq">
                                                    <p
                                                        className="MuiTypography-root styles_notification_label__M5clx MuiTypography-body2"
                                                        style={{ color: 'rgb(213, 93, 42)', border: '1px solid rgb(213, 93, 42)' }}
                                                    >
                                                        Tài khoản
                                                    </p>
                                                </div>
                                                <small className="styles_createdAt__cgZM_">
                                                    5 tháng trước
                                                </small>
                                            </div>
                                        </div>

                                        <div
                                            className="styles_notificationChild_container__vbuxp MuiBox-root css-dtg2nl"
                                            style={{ columnGap: 12 }}
                                        >
                                            <div className="styles_isRead___fiA9 MuiBox-root css-0" />
                                            <div className="MuiBox-root css-1821gv5">
                                                <div
                                                    style={{
                                                        color: 'rgb(121, 121, 121)',
                                                        fontSize: 14,
                                                        fontFamily: 'ggsr',
                                                        fontWeight: 400,
                                                    }}
                                                >
                                                    Tài khoản của bạn đã được kích hoạt
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </a>

                            </div>
                        </div>
                    )}

                    {/* TAB PANEL - IMPORTANT */}
                    {activeTab === 'PRODUCT' && (
                        <div
                            className="MuiTabPanel-root styles_tabPanel_container__M53so tabPanel"
                            role="tabpanel"
                        >
                            <div className="styles_notification_tabContainer__lUnx6 MuiBox-root css-0">

                                <div className="styles_dateLabel__tqB9r MuiBox-root css-0">
                                    <p className="MuiTypography-root MuiTypography-body1">
                                        Quá 30 ngày
                                    </p>
                                </div>

                                <a
                                    className="styles_mobile_rootBase__8z7PQ styles_notificationsItem__Y42KH styles_read__WIgTK"
                                    href="/my-account"
                                >
                                    <div className="MuiBox-root css-1hqz9cp">
                                        <div className="MuiBox-root css-c6deql">
                                            <div className="MuiBox-root css-1mcghfl">
                                                <div className="MuiBox-root css-1azo8rq">
                                                    <p
                                                        className="MuiTypography-root styles_notification_label__M5clx MuiTypography-body2"
                                                        style={{ color: 'rgb(213, 93, 42)', border: '1px solid rgb(213, 93, 42)' }}
                                                    >
                                                        Tài khoản
                                                    </p>
                                                </div>
                                                <small className="styles_createdAt__cgZM_">
                                                    5 tháng trước
                                                </small>
                                            </div>
                                        </div>

                                        <div
                                            className="styles_notificationChild_container__vbuxp MuiBox-root css-dtg2nl"
                                            style={{ columnGap: 12 }}
                                        >
                                            <div className="styles_isRead___fiA9 MuiBox-root css-0" />
                                            <div className="MuiBox-root css-1821gv5">
                                                <div
                                                    style={{
                                                        color: 'rgb(121, 121, 121)',
                                                        fontSize: 14,
                                                        fontFamily: 'ggsr',
                                                        fontWeight: 400,
                                                    }}
                                                >
                                                    Tài khoản của bạn đã được kích hoạt
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </a>

                                {/* ITEM 1 */}
                                <a
                                    className="styles_mobile_rootBase__8z7PQ styles_notificationsItem__Y42KH styles_read__WIgTK"
                                    href="/cart"
                                >
                                    <div className="MuiBox-root css-1hqz9cp">
                                        <div className="MuiBox-root css-c6deql">
                                            <div className="MuiBox-root css-1mcghfl">
                                                <div className="MuiBox-root css-vv12sd">
                                                    <p
                                                        className="MuiTypography-root styles_notification_label__M5clx MuiTypography-body2"
                                                        style={{ color: 'rgb(14, 25, 131)', border: '1px solid rgb(14, 25, 131)' }}
                                                    >
                                                        Đơn giá
                                                    </p>
                                                </div>
                                                <small className="styles_createdAt__cgZM_">
                                                    2 tháng trước
                                                </small>
                                            </div>
                                        </div>

                                        <div
                                            className="styles_notificationChild_container__vbuxp MuiBox-root css-dtg2nl"
                                            style={{ columnGap: 12 }}
                                        >
                                            <div className="styles_isRead___fiA9 MuiBox-root css-0" />
                                            <div className="MuiBox-root css-1821gv5">
                                                <div
                                                    style={{
                                                        color: 'rgb(121, 121, 121)',
                                                        fontSize: 14,
                                                        fontFamily: 'ggsr',
                                                        fontWeight: 400,
                                                    }}
                                                >
                                                    Sản phẩm Phil domina Hydroquinone Phil Inter (T/10gr)
                                                    đã có sự tăng giá bán so với lúc bạn để vào giỏ hàng,
                                                    vui lòng kiểm tra lại trước khi thanh toán!
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </a>

                                {/* ITEM 2 */}
                                <a
                                    className="styles_mobile_rootBase__8z7PQ styles_notificationsItem__Y42KH styles_read__WIgTK"
                                    href="/my-account"
                                >
                                    <div className="MuiBox-root css-1hqz9cp">
                                        <div className="MuiBox-root css-c6deql">
                                            <div className="MuiBox-root css-1mcghfl">
                                                <div className="MuiBox-root css-1azo8rq">
                                                    <p
                                                        className="MuiTypography-root styles_notification_label__M5clx MuiTypography-body2"
                                                        style={{ color: 'rgb(213, 93, 42)', border: '1px solid rgb(213, 93, 42)' }}
                                                    >
                                                        Tài khoản
                                                    </p>
                                                </div>
                                                <small className="styles_createdAt__cgZM_">
                                                    5 tháng trước
                                                </small>
                                            </div>
                                        </div>

                                        <div
                                            className="styles_notificationChild_container__vbuxp MuiBox-root css-dtg2nl"
                                            style={{ columnGap: 12 }}
                                        >
                                            <div className="styles_isRead___fiA9 MuiBox-root css-0" />
                                            <div className="MuiBox-root css-1821gv5">
                                                <div
                                                    style={{
                                                        color: 'rgb(121, 121, 121)',
                                                        fontSize: 14,
                                                        fontFamily: 'ggsr',
                                                        fontWeight: 400,
                                                    }}
                                                >
                                                    Tài khoản của bạn đã được kích hoạt
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    )}

                    {/* TAB PANEL - PROMOTION */}
                    {activeTab === 'PROMOTION' && (
                        <div
                            className="MuiTabPanel-root styles_tabPanel_container__M53so tabPanel"
                            role="tabpanel"
                        >
                            <div className="styles_notification_tabContainer__lUnx6 MuiBox-root css-0">

                                <div className="styles_dateLabel__tqB9r MuiBox-root css-0">
                                    <p className="MuiTypography-root MuiTypography-body1">
                                        Quá 30 ngày
                                    </p>
                                </div>

                                {/* ITEM 1 */}
                                <a
                                    className="styles_mobile_rootBase__8z7PQ styles_notificationsItem__Y42KH styles_read__WIgTK"
                                    href="/cart"
                                >
                                    <div className="MuiBox-root css-1hqz9cp">
                                        <div className="MuiBox-root css-c6deql">
                                            <div className="MuiBox-root css-1mcghfl">
                                                <div className="MuiBox-root css-vv12sd">
                                                    <p
                                                        className="MuiTypography-root styles_notification_label__M5clx MuiTypography-body2"
                                                        style={{ color: 'rgb(14, 25, 131)', border: '1px solid rgb(14, 25, 131)' }}
                                                    >
                                                        Đơn giá
                                                    </p>
                                                </div>
                                                <small className="styles_createdAt__cgZM_">
                                                    2 tháng trước
                                                </small>
                                            </div>
                                        </div>

                                        <div
                                            className="styles_notificationChild_container__vbuxp MuiBox-root css-dtg2nl"
                                            style={{ columnGap: 12 }}
                                        >
                                            <div className="styles_isRead___fiA9 MuiBox-root css-0" />
                                            <div className="MuiBox-root css-1821gv5">
                                                <div
                                                    style={{
                                                        color: 'rgb(121, 121, 121)',
                                                        fontSize: 14,
                                                        fontFamily: 'ggsr',
                                                        fontWeight: 400,
                                                    }}
                                                >
                                                    Sản phẩm Phil domina Hydroquinone Phil Inter (T/10gr)
                                                    đã có sự tăng giá bán so với lúc bạn để vào giỏ hàng,
                                                    vui lòng kiểm tra lại trước khi thanh toán!
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </a>

                                {/* ITEM 2 */}
                                <a
                                    className="styles_mobile_rootBase__8z7PQ styles_notificationsItem__Y42KH styles_read__WIgTK"
                                    href="/my-account"
                                >
                                    <div className="MuiBox-root css-1hqz9cp">
                                        <div className="MuiBox-root css-c6deql">
                                            <div className="MuiBox-root css-1mcghfl">
                                                <div className="MuiBox-root css-1azo8rq">
                                                    <p
                                                        className="MuiTypography-root styles_notification_label__M5clx MuiTypography-body2"
                                                        style={{ color: 'rgb(213, 93, 42)', border: '1px solid rgb(213, 93, 42)' }}
                                                    >
                                                        Tài khoản
                                                    </p>
                                                </div>
                                                <small className="styles_createdAt__cgZM_">
                                                    5 tháng trước
                                                </small>
                                            </div>
                                        </div>

                                        <div
                                            className="styles_notificationChild_container__vbuxp MuiBox-root css-dtg2nl"
                                            style={{ columnGap: 12 }}
                                        >
                                            <div className="styles_isRead___fiA9 MuiBox-root css-0" />
                                            <div className="MuiBox-root css-1821gv5">
                                                <div
                                                    style={{
                                                        color: 'rgb(121, 121, 121)',
                                                        fontSize: 14,
                                                        fontFamily: 'ggsr',
                                                        fontWeight: 400,
                                                    }}
                                                >
                                                    Tài khoản của bạn đã được kích hoạt
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </a>

                                <a
                                    className="styles_mobile_rootBase__8z7PQ styles_notificationsItem__Y42KH styles_read__WIgTK"
                                    href="/my-account"
                                >
                                    <div className="MuiBox-root css-1hqz9cp">
                                        <div className="MuiBox-root css-c6deql">
                                            <div className="MuiBox-root css-1mcghfl">
                                                <div className="MuiBox-root css-1azo8rq">
                                                    <p
                                                        className="MuiTypography-root styles_notification_label__M5clx MuiTypography-body2"
                                                        style={{ color: 'rgb(213, 93, 42)', border: '1px solid rgb(213, 93, 42)' }}
                                                    >
                                                        Tài khoản
                                                    </p>
                                                </div>
                                                <small className="styles_createdAt__cgZM_">
                                                    5 tháng trước
                                                </small>
                                            </div>
                                        </div>

                                        <div
                                            className="styles_notificationChild_container__vbuxp MuiBox-root css-dtg2nl"
                                            style={{ columnGap: 12 }}
                                        >
                                            <div className="styles_isRead___fiA9 MuiBox-root css-0" />
                                            <div className="MuiBox-root css-1821gv5">
                                                <div
                                                    style={{
                                                        color: 'rgb(121, 121, 121)',
                                                        fontSize: 14,
                                                        fontFamily: 'ggsr',
                                                        fontWeight: 400,
                                                    }}
                                                >
                                                    Tài khoản của bạn đã được kích hoạt
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </a>

                                <a
                                    className="styles_mobile_rootBase__8z7PQ styles_notificationsItem__Y42KH styles_read__WIgTK"
                                    href="/my-account"
                                >
                                    <div className="MuiBox-root css-1hqz9cp">
                                        <div className="MuiBox-root css-c6deql">
                                            <div className="MuiBox-root css-1mcghfl">
                                                <div className="MuiBox-root css-1azo8rq">
                                                    <p
                                                        className="MuiTypography-root styles_notification_label__M5clx MuiTypography-body2"
                                                        style={{ color: 'rgb(213, 93, 42)', border: '1px solid rgb(213, 93, 42)' }}
                                                    >
                                                        Tài khoản
                                                    </p>
                                                </div>
                                                <small className="styles_createdAt__cgZM_">
                                                    5 tháng trước
                                                </small>
                                            </div>
                                        </div>

                                        <div
                                            className="styles_notificationChild_container__vbuxp MuiBox-root css-dtg2nl"
                                            style={{ columnGap: 12 }}
                                        >
                                            <div className="styles_isRead___fiA9 MuiBox-root css-0" />
                                            <div className="MuiBox-root css-1821gv5">
                                                <div
                                                    style={{
                                                        color: 'rgb(121, 121, 121)',
                                                        fontSize: 14,
                                                        fontFamily: 'ggsr',
                                                        fontWeight: 400,
                                                    }}
                                                >
                                                    Tài khoản của bạn đã được kích hoạt
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </a>

                            </div>
                        </div>
                    )}

                    {/* SEE MORE */}
                    <div className="styles_seeMore_container__VUTpz MuiBox-root css-0">
                        <a
                            className="styles_mobile_rootBase__8z7PQ styles_viewAll__5vUfK"
                            href="/notifications?tab=IMPORTANT"
                        >
                            <p className="MuiTypography-root styles_viewAllTitle__izmDc MuiTypography-body1 MuiTypography-displayInline">
                                Xem tất cả
                            </p>
                        </a>
                    </div>
                </div>
            </ul>
        </div>
    )
}
